// extracted by mini-css-extract-plugin
export default {"mainbody":"MainBody_mainbody__2gq6e"};